export class Visiti {
    id: number;
   
    leave: string;
   
    constructor() {
        this.id = null;
      
        this.leave = '';
       
    }
}
